import axios from "axios";
import axiosHttp from "./interceptor";

const baseURL = process.env.REACT_APP_BASE_URL;

export const validateSigninUser = async (signInUserDetails) => {
	try {
		const response = await axios.post(
			`${baseURL}api/Accounts/Login`,
			signInUserDetails
		);
		return response?.data;
	} catch (error) {
		console.error(error);
	}
};

export const registerUser = async (userRegistrationObj) => {
	try {
		const response = await axiosHttp.post(
			`/api/Accounts/Register`,
			userRegistrationObj
		);
		return response?.data;
	} catch (error) {
		console.error(error);
	}
};

export const sendForgotPasswordLink = async (forgotPasswordObj) => {
	try {
		const response = await axiosHttp.post(
			`api/ForgotPasswordLink`,
			forgotPasswordObj
		);
		return response?.data;
	} catch (error) {
		console.error(error);
	}
};
